export default __webpack_public_path__ + "19a68481da84e2fdfe4e35df154f2f02.jpg";